// req_type → ป้ายไทย + หมวดสี (mapping จาก docs/handoff/02_design_system.md)
export const REQ_TYPES = {
  proforma_invoice:     { t: 'Proforma Invoice',        k: 'money' },
  payment_proof:        { t: 'หลักฐานโอน / SWIFT',       k: 'money' },
  commercial_invoice:   { t: 'Commercial Invoice',      k: 'money' },
  packing_list:         { t: 'Packing List',            k: 'ship' },
  awb:                  { t: 'Air Waybill',             k: 'ship' },
  bl:                   { t: 'Bill of Lading',          k: 'ship' },
  booking_confirmation: { t: 'Booking Confirmation',    k: 'ship' },
  insurance:            { t: 'ประกันภัยขนส่ง',           k: 'ship' },
  certificate_of_origin:{ t: 'CO / Form สิทธิ',          k: 'origin' },
  phytosanitary:        { t: 'Phytosanitary Cert',      k: 'permit' },
  fumigation:           { t: 'ใบรับรองรมยา (ISPM-15)',   k: 'permit' },
  permit_forest:        { t: 'ใบอนุญาตกรมป่าไม้',        k: 'permit' },
  permit_tisi:          { t: 'ใบอนุญาต มอก. (สมอ.)',     k: 'permit' },
  permit_fda:           { t: 'ใบอนุญาต อย.',             k: 'permit' },
  permit_excise:        { t: 'สรรพสามิต',                k: 'permit' },
  import_license_other: { t: 'ใบอนุญาต/หนังสือรับรองอื่น', k: 'permit' },
  product_dossier:      { t: 'ใบข้อมูลสินค้า (ให้ broker)', k: 'customs' },
  declaration:          { t: 'ใบขนขาเข้า',               k: 'customs' },
  duty_receipt:         { t: 'ใบเสร็จอากร / VAT',        k: 'customs' },
  goods_receipt:        { t: 'ใบตรวจรับเข้าคลัง',        k: 'wh' },
  freight_invoice:      { t: 'Freight Invoice (ค่าระวาง)', k: 'ship' },
  attachment:           { t: 'เอกสารแนบ',                 k: 'customs' },
};

export const reqLabel = rt => REQ_TYPES[rt]?.t ?? rt;
export const reqCat   = rt => REQ_TYPES[rt]?.k ?? 'customs';

// คำอธิบายต่อเอกสาร — โชว์ตอนเอาเมาส์ไปวางที่การ์ด (มือใหม่ต้องรู้ว่าใส่อะไร)
export const REQ_HELP = {
  proforma_invoice:     'ใบเสนอราคา/แจ้งหนี้ล่วงหน้าจาก supplier — ใช้ก่อนโอนเงิน บอกรายการ+ราคา (ขอจาก supplier)',
  payment_proof:        'หลักฐานการโอนเงิน (สลิป/SWIFT) ที่โอนให้ supplier — บัญชีเป็นคนออก',
  commercial_invoice:   'ใบแจ้งหนี้การค้าตัวจริงจาก supplier — ใช้สำแดงมูลค่าต่อศุลกากร (ขอจาก supplier)',
  packing_list:         'ใบรายการบรรจุ — แต่ละกล่องมีอะไร กี่ชิ้น น้ำหนัก (ขอจาก supplier)',
  awb:                  'Air Waybill — ใบตราส่งทางอากาศ (จากสายการบิน/forwarder)',
  bl:                   'Bill of Lading — ใบตราส่งทางเรือ (จาก forwarder/สายเรือ)',
  booking_confirmation: 'ใบยืนยันจองระวาง/ตู้ (จาก forwarder)',
  insurance:            'กรมธรรม์/ใบรับรองประกันภัยขนส่งสินค้า — เฉพาะตู้ที่ทำประกัน (ใช้เคลม+รวมใน CIF)',
  certificate_of_origin:'หนังสือรับรองถิ่นกำเนิด/Form สิทธิ FTA — ให้ supplier ขอที่ต้นทาง ใช้ลดอากร (ออกย้อนหลังไม่ได้)',
  phytosanitary:        'ใบรับรองสุขอนามัยพืชจากต้นทาง (ของไม้/พืช) — ออกย้อนหลังไม่ได้ ให้ supplier ขอก่อนของออก',
  fumigation:           'ใบรับรองการรมยา/ISPM-15 (ลังไม้/พาเลท) — จากต้นทาง',
  permit_forest:        'ใบอนุญาตนำเข้าไม้ กรมป่าไม้ — เรายื่น/ให้ broker ทำในไทย',
  permit_tisi:          'ใบอนุญาต มอก. (สมอ.) — สินค้าที่มี มอก.บังคับ เช่น power bank ต้องมีก่อนนำเข้า (ในไทย)',
  permit_fda:           'ใบอนุญาต อย. — อาหาร/เครื่องสำอาง/ภาชนะสัมผัสอาหารบางชนิด (ในไทย)',
  permit_excise:        'เอกสารสรรพสามิต — สินค้าที่เสียภาษีสรรพสามิต เช่น แบตเตอรี่ (ในไทย)',
  import_license_other: 'ใบอนุญาต/หนังสือรับรองนำเข้าอื่นๆ ตามหน่วยงานที่เกี่ยวข้อง (ในไทย เช่น NSW กรมอุทยานฯ)',
  product_dossier:      'ใบข้อมูลสินค้า+รูป ที่ "เรา" ทำส่งให้ broker ดูแล้วบอกพิกัด (ไม่ใช่เอกสารจาก supplier) — ใส่สินค้าในตู้ (＋ สินค้า) แล้วกดปุ่ม "ใบข้อมูลสินค้า"',
  declaration:          'ใบขนสินค้าขาเข้า — broker ทำตอนเดินพิธีศุลกากร',
  duty_receipt:         'ใบเสร็จค่าอากร + VAT ที่ชำระกับศุลกากร',
  goods_receipt:        'ใบตรวจรับสินค้าเข้าคลัง — ยืนยันของถึงครบตอนของมา',
  freight_invoice:      'ใบแจ้งหนี้ค่าระวาง/ค่าขนส่ง จาก forwarder/สายเรือ — รวมในต้นทุนนำเข้า',
  attachment:           'เอกสารแนบอื่นๆ ที่ไม่มีช่องเฉพาะ — เก็บไว้กับตู้นี้',
};
export const reqHelp = rt => REQ_HELP[rt] ?? '';

// เดา req_type จากชื่อไฟล์ (เฟสแรกตาม 03_: ชื่อไฟล์พอ ไม่ต้อง OCR)
const FILE_HINTS = [
  [/^(pi|proforma)/i, 'proforma_invoice'],
  [/^(inv|invoice|ci)/i, 'commercial_invoice'],
  [/^(pl|packing)/i, 'packing_list'],
  [/^(bl|obl|hbl)/i, 'bl'],
  [/^awb/i, 'awb'],
  [/^(bkg|booking)/i, 'booking_confirmation'],
  [/^(co|form|jtepa|atiga|rcep|acfta)/i, 'certificate_of_origin'],
  [/^(phyto)/i, 'phytosanitary'],
  [/^(swift|slip|tt|pay)/i, 'payment_proof'],
  [/^(decl|ใบขน)/i, 'declaration'],
  [/(freight|ระวาง|ค่าขนส่ง)/i, 'freight_invoice'],
];
export function guessReqType(fileName) {
  for (const [re, rt] of FILE_HINTS) if (re.test(fileName)) return rt;
  return null;
}

export const MODE_LABEL = { air: 'AIR', sea: 'SEA' };
export const STATUS_FLOW = [
  'ordered','paid','payment_confirmed','ready_to_ship','pickup_arranged',
  'in_transit','docs_received','form_verified','customs_submitted',
  'duty_paid','delivered','received',
];
export const PHASE_OF_STATUS = {
  ordered: 'Order & Pay', paid: 'Order & Pay', payment_confirmed: 'Order & Pay',
  ready_to_ship: 'Ship & Book', pickup_arranged: 'Ship & Book', in_transit: 'Ship & Book',
  docs_received: 'Docs & Form', form_verified: 'Docs & Form',
  customs_submitted: 'Customs', duty_paid: 'Customs',
  delivered: 'Goods In', received: 'Goods In',
};
